// extracted by mini-css-extract-plugin
export default {"summary":"u8M13aUO--styles_summary__-mVQW","desc1":"u8M13aUO--styles_desc1__qaxkj","desc2":"u8M13aUO--styles_desc2__+ykVY","shimmer":"u8M13aUO--styles_shimmer__iWTDm"};